window.arAssignmentResubmitFormatter = function(value, row) {
    let html = '';
    if (parseInt(row.resubmit, 10) === 1) {
        return html;
    }
    if (parseInt(row.decision_period_expired, 10) === 1 || parseInt(row.count_rejected, 10) >= 2) {
        html += '<a class="button-resubmit button btn btn-outline-secondary btn-sm w-100 me-3" data-id="' + row.id + '">';
        html += '<i class="fal fa-rotate"></i>';
        html += __('Resubmit');
        html += '</a>';
    }
    return html;
};
